import PropTypes from 'prop-types';
import React from 'react';

import BackgroundImage from '$partials/media/background-image';
import { formatUrlWithActiveFund } from '$utilities/format';
import Link from '$partials/global/link';

const NewsItem = ({
    className = '',
    listingImage,
    listingText,
    style = 'listing',
    title,
    openToModal = false,
    url: originalUrl,
}) => {
    const Component = openToModal ? Link : 'a';
    const url = formatUrlWithActiveFund(originalUrl);

    return (
        <div className={`${className}`}>
            <Component
                href={url}>
                <figure
                    className={`aspect-3/2 sm:aspect-9/5 overflow-hidden relative ${style === 'listing' ? 'rounded-t-lg sm:rounded-lg' :  'rounded-lg'}`}>
                    <BackgroundImage
                        containerClassName=''
                        {...listingImage} />
                </figure>
                <div className='max-sm:bg-white px-20 py-40 sm:py-20 sm:px-0 md:py-30 rounded-b-lg'>
                    <h3 className='type-style-5 item-title'>
                        {title}
                    </h3>

                    {listingText &&
                      <p className='mt-10'>
                          {listingText}
                      </p>
                    }

                </div>
            </Component>
        </div>
    );
};

/* ========================================================================= */
/* Typing and exports */
/* ========================================================================= */

const propTypes = {
    className: PropTypes.string,
    listingImage: PropTypes.object,
    listingText: PropTypes.string,
    style: PropTypes.string,
    openToModal: PropTypes.bool,
    title: PropTypes.string,
    url: PropTypes.string,
};

NewsItem.propTypes = propTypes;

export default NewsItem;
